export class ZValidation
{
    /**
     * バリデーション対象のデータオブジェクト
     */
    private _data: object;

    /**
     * バリデーションルール
     */
    private _rules: object;

    /**
     * 項目名
     */
    private _labels: object;

    /**
     * エラー
     */
    private _errors: object;

    get errors(): object {
        return this._errors;
    }

    /**
     * コンストラクタ
     * @param data  バリデーション対象のデータオブジェクト
     * @param rules バリデーションルール
     */
    constructor(data: object, rules: object, labels: object)
    {
        this._data = data;
        this._rules = rules;
        this._labels = labels;
        this._errors = {};

        // エラーをクリアする
        this.clearErrorElement();
    }

    /**
     * バリデーション実行
     */
    public validation(): boolean
    {
        // dataオブジェクト単位でループしてチェック内容を解析していく
        Object.keys(this._data).forEach((key: string) => {
            // キーがrulesの中に存在している場合に解析をしてチェックする
            // [|]があれば配列にする
            let rules: Array<string> = this._rules[key]?.split('|');

            // required
            if (!this.checkRequire(key, rules)) {
                return false;
            }

            // min,max(入力ある場合のみチェック)
            if (this._data[key] != '' && !this.checkSize(key, rules)) {
                return false;
            }
        });

        return Object.keys(this._errors).length === 0;
    }

    private checkRequire(key: string, rules: Array<string>): boolean
    {
        let result: boolean = true;

        // requiredがあったらチェックする
        rules.forEach((rule) => {
            if (rule == 'required') {
                if (this._data[key] == '') {
                    // エラー
                    this.addError(
                        key,
                        this._labels[key] + 'は必須です。'
                    );
                    result = false;
                }
            }
        });

        return result;
    }

    private checkSize(key: string, rules: Array<string>): boolean
    {
        let result: boolean = true;
        let size: number = 0;

        // max or minがあったら:で分割する
        rules.forEach((rule) => {
            // maxのチェック
            if (rule.indexOf('max:') > -1) {
                size = parseInt(rule.split('max:')[1]);

                if (this.countCharacter(this._data[key]) > size) {
                    // エラー
                    this.addError(
                        key,
                        this._labels[key] + 'は最大' + size + '文字以内で入力してください。'
                    );
                    result = false;
                }
            }
        });      

        return result;
    }

    private clearErrorElement(): void
    {
        // dataオブジェクトをもとに[id_error]のタグを削除する
        Object.keys(this._data).forEach((value: string) => {
            document.getElementById(value + '_error')?.remove();
        });
    }

    private addError(key: string, message: string): void
    {
        this._errors[key] = message;
    }

    private countCharacter(value: string): number
    {
        const segmenter = new Intl.Segmenter('ja', {granularity: "grapheme"});
        return [...segmenter.segment(value)].length;
    }
}